import { takeLatest, call, put } from 'redux-saga/effects'
import { LINK_API } from "../../../constants/API"
import fetchData from "../fetchData"
import { getCollectionListOfUser, getCollectionListOfUserFailure, getCollectionListOfUserSuccess } from "../../reducer/config.user.detail/collectionListOfUserSlice"

function* fetchCollectionListOfUser (payload) {
    try {
        const params = {
            size: 12,
            page: payload?.payload?.page || 1,
            creator: payload?.payload?.creator,
            likeAddress: payload?.payload?.likeAddress
        }

        const url = LINK_API.GET_LIST_COLLECTIONS

        const response = yield call(fetchData, url, "GET", {} , params)

        const data = response.data

        yield put({type: getCollectionListOfUserSuccess().type, payload: data})

    } catch (error) {
        yield put({ type: getCollectionListOfUserFailure().type })
        
    }
}

const collectionListOfUserSaga = [
    takeLatest(getCollectionListOfUser().type, fetchCollectionListOfUser)
]

export default collectionListOfUserSaga